const generateLocations = (entries) => {
	const locations = [];
	entries.forEach((course) => {
		if (course.hasOwnProperty('lat') && course.hasOwnProperty('long')) {
			const id = `${course.lat}_${course.long}`;
			const location = {
				count: 1,
				lat: parseFloat(course.lat),
				long: parseFloat(course.long),
				venue: course.venue4,
				postcode: course.postcode,
				related: [course],
			};
			if (locations.hasOwnProperty(id)) {
				locations[id].count += 1;
				locations[id].related.push(course);
			} else {
				locations[id] = location;
			}
		}
	});

	// Flatten the array
	const output = [];
	Object.entries(locations).forEach((location) => {
		output.push(location[1]);
	});

	return output;
};

export default generateLocations;
